import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Input from "../../../components/ui/Input";
import Button from "../../../components/ui/Button";
import GoogleSignInButton from "./GoogleSignInButton";
import { login } from "../../../services/authService";
import { navigateAfterAuth } from "../../../utils/postAuthNavigation";

const LoginForm = ({ onNeedsConfirmation, onSwitchToSignup }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const result = await login({ email, password });

      if (result.ok) {
        await navigateAfterAuth(navigate, location.state);
        return;
      }

      if (result.data?.needsConfirmation) {
        onNeedsConfirmation?.(result.data.email || email);
        return;
      }

      setError(result.data?.message || "Não foi possível entrar. Tente novamente.");
    } catch {
      setError("Erro de conexão. Verifique sua internet e tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <Input
        label="E-mail"
        type="email"
        required
        autoComplete="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="seu@email.com"
      />
      <Input
        label="Senha"
        type="password"
        required
        autoComplete="current-password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="••••••••"
      />

      {error && (
        <p className="text-sm text-destructive" role="alert">
          {error}
        </p>
      )}

      <Button type="submit" size="lg" fullWidth loading={loading} disabled={loading}>
        Entrar
      </Button>

      <GoogleSignInButton />

      <p className="text-center text-sm text-muted-foreground">
        Ainda não tem conta?{" "}
        <button
          type="button"
          className="text-primary font-medium hover:underline"
          onClick={onSwitchToSignup}
        >
          Criar conta
        </button>
      </p>
    </form>
  );
};

export default LoginForm;
